import { uniq } from 'lodash';
import { GenPartial } from 'typeormgen';
import Scene from './scene.entity';

export function pageCount(total: number) {
	return `${Math.floor(total / 8) > 0 ? Math.floor(total / 8) : ''} ${
		total % 8 > 0 ? (total % 8) + '/8' : ''
	}`.trim();
}

export function getUniqueProdIds(scenes: GenPartial<Scene>[]) {
	return uniq(scenes.map((s) => Number(s.prod_id)));
}
